module.exports = __webpack_public_path__ + "assets/img/ico-5.768b77c4.webp";